module.exports = __webpack_public_path__ + "img/vertical_6_2_5010.4f90a8cf.png";